// app/helpers/interactions/index.js
import { buildContext } from "./context";
import { makeHandleMouseDown } from "./handlersMouseDown";
import { makeHandleMouseMove } from "./handlersMouseMove";
import { makeHandleMouseUp } from "./handlersMouseUp";
import { makeHandleWheel } from "./handlersWheel";
import { makeTouchHandlers } from "./handlersTouch";
import { makeHandleKeyDown } from "./handlersKeyDown";

export const createInteractionHandlers = (args) => {
  const ctx = buildContext(args);

  const handleMouseDown = makeHandleMouseDown(ctx);
  const handleMouseMove = makeHandleMouseMove(ctx);
  const handleMouseUp = makeHandleMouseUp(ctx);
  const handleWheel = makeHandleWheel(ctx);
  const { handleTouchStart, handleTouchMove, handleTouchEnd } =
    makeTouchHandlers(ctx, handleMouseDown, handleMouseMove);
  const handleKeyDown = makeHandleKeyDown(ctx);

  return {
    // expose helpers that callers expect
    ctx,
    getCanvasPoint: ctx.getCanvasPoint,
    addGuideline: ctx.addGuideline,

    // handlers
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    handleWheel,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    handleKeyDown,
  };
};
